import React, { useEffect, useRef, useState } from 'react';
import './NominationInfo.css';

export const DOZEN_NOMINATION_HELP = {
  podium: 'Топ 3 по количеству очков за неделю. При одинаковом количестве очков выше тот, у кого меньше среднее время.',
  fastest: 'Топ 3 по скорости закрытия всех 12 слов. Берётся лучшее время за неделю.',
  full: 'Топ 3 по количеству полных дюжин. Место считается по их числу, а не по тому, сыграны ли все дни.',
  regulars: 'Сыграны все 7 игр.'
};

export const WORD_NOMINATION_HELP = {
  podium: 'Топ 3 по количеству очков за неделю. При одинаковом количестве очков выше тот, у кого меньше среднее время.',
  fastest: 'Топ 3 по лучшему времени угадывания слова. Берётся лучшее время за неделю.',
  perfect: 'Угадал все слова недели.'
};

function NominationInfo({ text }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onPointer = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('pointerdown', onPointer);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <span className="nom-info" ref={rootRef}>
      <button
        type="button"
        className="nom-info__btn"
        aria-expanded={open}
        aria-label="Пояснение номинации"
        onClick={() => setOpen((value) => !value)}
      >
        i
      </button>
      {open && (
        <span className="nom-info__pop" role="tooltip">
          {text}
        </span>
      )}
    </span>
  );
}

export default NominationInfo;
